import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import { setOriginalUrlParameters } from '../../shared/actions';
import AddEmail from '../addEmail/AddEmail';
import AddPhone from '../addPhone/AddPhone';
import Applications from '../applications/Applications';
import HelloPage from '../auth/HelloPage';
import LoginConfirmationPage from '../auth/LoginConfirmationPage';
import RegistrationPage from '../auth/RegistrationPage';
import AuthoritySelection from '../authoritySelection/AuthoritySelection';
import Calendar from '../calendar/Calendar';
import CalendarEvent from '../calendar/CalendarEvent';
import Discussions from '../discussions/Discussions';
import FAQS from '../faqs/FAQS';
import Home from '../home/Home';
import MessageDetails from '../messages/MessageDetails';
import Messages from '../messages/Messages';
import MyCity from '../myCity/MyCity';
import NewReport from '../newReport/NewReport';
import PaymentConfirmation from '../payments/PaymentConfirmation';
import Payments from '../payments/Payments';
import Phonebook from '../phonebook/Phonebook';
import Privacy from '../privacy/Privacy';
import Profile from '../profile/Profile';
import ReportDetails from '../reports/ReportDetails';
import Reports from '../reports/Reports';
import RouteHandler from '../route/RouteHandler';
import TutorialPageContainer from '../startup/Tutorial';

const AUTH_FLOW_ROUTES = [
  '/hello',
  '/login-confirmation',
  '/registration-page',
];

class ProtectedRoutes extends Component {
  componentDidMount() {
    this.rememberOriginalRoute();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.location.pathname !== this.props.location.pathname ||
      prevProps.location.search !== this.props.location.search ||
      prevProps.token !== this.props.token
    ) {
      this.rememberOriginalRoute();
    }
  }

  rememberOriginalRoute() {
    const { token, location, params, setOriginalUrlParameters } = this.props;
    if (!location) return;

    const pathName = location.pathname || '';
    if (token || AUTH_FLOW_ROUTES.includes(pathName)) {
      return;
    }

    const search = location.search || '';
    const requestedRoute = `${pathName}${search}`;

    if (params?.redirect_route === requestedRoute) {
      return;
    }

    setOriginalUrlParameters({
      ...(params || {}),
      redirect_route: requestedRoute,
    });
  }

  render() {
    let { token, authority, mobile, location, modulesEnabled } = this.props;
    let comp = null;
    const hasQueryParams = !!location.search;

    let routes = createRoutesBasedOnModules(
      modulesEnabled,
      token,
      authority,
      mobile
    );

    if (!hasQueryParams && comp)
      routes = [comp].concat(routes);


    return routes;
  }
}

const createRouteWithRequirements = (
  component,
  url,
  requirements,
  injections,
  exact
) => {
  return (
    <Route
      exact={!!exact}
      key={url}
      path={url}
      render={() => {
        if (requirements.includes('token') && !injections.token) {
          return <Redirect to="/hello" />;
        }

        if (
          requirements.includes('unauthenticated') &&
          injections.token &&
          injections.authority
        ) {
          return <Redirect to="/home" />;
        }

        if (requirements.includes('mobile') && !injections.mobile) {
          return <Redirect to={`/addPhone#from=${url}`} />;
        }

        if (requirements.includes('authority') && !injections.authority) {
          console.log('Cae from URL:', url);

          return (
            <Redirect
              to={{
                pathname: '/authoritySelection',
                state: { from: url },
              }}
            />
          );
        }

        return component;
      }}
    />
  );
};

var mapStateToProps = (state, ownProps) => {
  return {
    token: state.authReducer.auth_token,
    mobile: state.profileReducer.profile.mobile,
    authority: state.profileReducer.profile.authority,
    modulesEnabled: state.otherReducer.modules,
    params: state.otherReducer.params,
    location: ownProps.location,
  };
};

var mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setOriginalUrlParameters,
    },
    dispatch
  );

const ConnectedProtectedRoutes = connect(
  mapStateToProps,
  mapDispatchToProps
)(ProtectedRoutes);
export default ConnectedProtectedRoutes;

//TODO: Find out why moving Switch here doesnt work.
//TODO: MOVE THIS

function createRoutesBasedOnModules(modulesEnabled, token, authority, mobile) {
  const modulesEnabledNamesArray = modulesEnabled.map((item) => item.name);
  const entries = [];

  const seenTutorial =
    typeof window !== 'undefined' &&
    localStorage.getItem('seenTutorial') === 'true';

  if (!seenTutorial) {
    localStorage.setItem('seenTutorial', true);
    entries.push(
      createRouteWithRequirements(
        <TutorialPageContainer key={'tutorial-page'} />,
        '/',
        ['unauthenticated'],
        { token, authority },
        true
      )
    );
  }

  if (seenTutorial && !token) {
    entries.push(
      createRouteWithRequirements(
        <Redirect to="/hello" />,
        '/',
        ['unauthenticated'],
        { token, authority },
        true
      )
    );
  }

  if (seenTutorial && token && !authority) {
    entries.push(
      createRouteWithRequirements(
        <Redirect to="/authoritySelection" />,
        '/',
        ['token'],
        { token, authority },
        true
      )
    );
  }

  if (seenTutorial && token && authority) {
    entries.push(
      createRouteWithRequirements(
        <Redirect to="/home" />,
        '/',
        ['token', 'authority'],
        { token, authority },
        true
      )
    );
  }

  const defaultEntries = [
    createRouteWithRequirements(
      <HelloPage key={'hello-page'} />,
      '/hello',
      ['unauthenticated'],
      { token, authority },
      true
    ),
    createRouteWithRequirements(
      <RouteHandler key={'route-handler'} />,
      '/route',
      ['token'],
      { token }
    ),
    createRouteWithRequirements(
      <LoginConfirmationPage key={'login-confirmation'} />,
      '/login-confirmation',
      ['unauthenticated'],
      { token, authority },
      true
    ),
    createRouteWithRequirements(
      <RegistrationPage key={'registration-page'} />,
      '/registration-page',
      ['unauthenticated'],
      { token, authority },
      true
    ),
    createRouteWithRequirements(
      <AuthoritySelection key={'authority-selection'} />,
      '/authoritySelection',
      ['token'],
      { token, authority }
    ),
    createRouteWithRequirements(
      <Home key={'home-page'} />,
      '/home',
      ['token', 'authority'],
      { token, authority },
      true
    ),

    createRouteWithRequirements(
      <AddEmail key={'add-email'} />,
      '/addEmail',
      ['token', 'authority'],
      { token, authority }
    ),
    createRouteWithRequirements(
      <AddPhone key={'add-phone'} />,
      '/addPhone',
      ['token', 'authority'],
      { token, authority }
    ),
    createRouteWithRequirements(
      <Profile key={'profile-page'} />,
      '/profile',
      ['token', 'authority'],
      { token, authority }
    ),
    createRouteWithRequirements(
      <Privacy key={'privacy-page'} />,
      '/privacy',
      ['token', 'authority'],
      { token, authority }
    ),
  ];

  entries.push(...defaultEntries);

  if (modulesEnabledNamesArray.includes('messages')) {
    entries.push(
      createRouteWithRequirements(
        <Messages key={'messages-page'} />,
        '/messages',
        ['token', 'authority'],
        { token, authority },
        true
      )
    );
    entries.push(
      createRouteWithRequirements(
        <MessageDetails key={'message-details'} />,
        '/messages/:id',
        ['token', 'authority'],
        { token, authority }
      )
    );
  }

  if (modulesEnabledNamesArray.includes('mycity')) {
    entries.push(
      createRouteWithRequirements(
        <MyCity key={'my-city-page'} />,
        '/myCity',
        ['token', 'authority'],
        { token, authority },
        true
      )
    );
  }

  if (modulesEnabledNamesArray.includes('reports')) {
    entries.push(
      createRouteWithRequirements(
        <Reports key={'reports-page'} />,
        '/reports',
        ['token', 'authority'],
        { token, authority },
        true
      )
    );
    entries.push(
      createRouteWithRequirements(
        <ReportDetails key={'report-details'} />,
        '/reports/:id',
        ['token', 'authority'],
        { token, authority }
      )
    );

    entries.push(
      createRouteWithRequirements(
        <NewReport key={'new-report'} />,
        '/newReport',
        ['token', 'authority'],
        { token, authority },
        true
      )
    );
  }

  if (modulesEnabledNamesArray.includes('phones')) {
    entries.push(
      createRouteWithRequirements(
        <Phonebook key={'phonebook-page'} />,
        '/phonebook',
        ['token', 'authority'],
        { token, authority },
        true
      )
    );
  }

  if (modulesEnabledNamesArray.includes('faqs')) {
    entries.push(
      createRouteWithRequirements(
        <FAQS key={'faqs-page'} />,
        '/faqs',
        ['token', 'authority'],
        { token, authority },
        true
      )
    );
  }

  if (modulesEnabledNamesArray.includes('calendar')) {
    entries.push(
      createRouteWithRequirements(
        <Calendar key={'calendar-page'} />,
        '/calendar',
        ['token', 'authority'],
        { token, authority },
        true
      )
    );
    entries.push(
      createRouteWithRequirements(
        <CalendarEvent key={'calendar-event'} />,
        '/calendar/:eventId',
        ['token', 'authority'],
        { token, authority },
        true
      )
    );
  }

  // discussions
  if (modulesEnabledNamesArray.includes('discussions')) {
    entries.push(
      createRouteWithRequirements(
        <Discussions key={'discussions-page'} />,
        '/discussions',
        ['token', 'authority'],
        { token, authority },
        true
      )
    );
  }

  // bills and payments
  if (modulesEnabledNamesArray.includes('bills')) {
    entries.push(
      createRouteWithRequirements(
        <Payments key={'payments-page'} />,
        '/payments',
        ['token', 'authority'],
        { token, authority },
        true
      )
    );

    entries.push(
      createRouteWithRequirements(
        <PaymentConfirmation key={'payment-confirmation'} />,
        '/payments/:code',
        ['token', 'authority'],
        { token, authority }
      )
    );
  }

  if (modulesEnabledNamesArray.includes('form_applications')) {
    entries.push(
      createRouteWithRequirements(
        <Applications key={'applications-page'} />,
        '/applications',
        ['token', 'authority'],
        { token, authority },
        true
      )
    );
  }

  return entries;
}
